export default __webpack_public_path__ + "static/assets/transportise-log.98f71e19a7049fea50b39882d9fa8758.png";